<div class="card panel-flat-color secondary-panel">
    <div (click)="expandOrCollapse()" [ngClass]="{'pointer': !editMode}" class="panel-flat-header">
        <panel-chevron [showBody]="isShowSettings"></panel-chevron>
        <h3>Company Settings</h3>
        <div (click)="$event.stopPropagation()" class="float-end header-button-container">
            @if (isShowSettings && !editMode && !editLock && allowEdit) {
                <button class="ace-btn btn-text has-icon"
                        (click)="setEditMode()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (isShowSettings && editMode) {
                <button class="ace-btn btn-text has-icon" (click)="save()">
                    <i class="fa fa-save"></i>
                </button>
            }
            @if (isShowSettings && editMode) {
                <button class="ace-btn btn-text has-icon" (click)="cancelEdit()">
                    <i class="fa fa-close"></i>
                </button>
            }
        </div>
    </div>
    @if (isShowSettings) {
        <div class="card-body" style="min-height: 100px;">
            @if (isLoading) {
                <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
            }
            @if (!isLoading) {
                <div class="row">
                    <div class="col-lg-6">
                        @if (!company.parentId) {
                            <div class="setting">
                                <span class="settings-label" style="margin-right: 6px; font-weight: bold;">Company
                                    Collectors:</span>
                                <span>
                                    @if (editMode) {
                                        <a anchor-route
                                           [sref]="{ target: 'companyCollectors', options: {companyID: company.companyID} }">
                                            Manage ({{ company.collectorCount || 0 }})
                                        </a>
                                    }
                                    @if (!editMode) {
                                        <span>{{ company.collectorCount || 0 }}</span>
                                    }
                                </span>
                            </div>
                        }
                        @if (isShowSettings) {
                            <div class="setting">
                                @if (company.parentId) {
                                    <div>
                                        <span style="margin-right: 10px; font-weight: bold;">
                                            Use Top Level Company's Vendor Code Mapping:
                                        </span>
                                        <ws-switch [(ngModel)]="options.useParentVendorFlag"
                                                   [disabled]="!editMode"
                                                   size="small">
                                        </ws-switch>
                                    </div>
                                }
                                @if (!company.useParentVendorCodes || !company.parentId) {
                                    <span>
                                        <span style="margin-right: 6px; font-weight: bold;">Company Vendor Code
                                            Mapping: </span>
                                        @if (editMode) {
                                            <a anchor-route
                                               [sref]="{ target: 'companyVendorCodes', options: {companyId: companyId} }">Manage
                                                @if (vendorCodeCountLoading) {
                                                    (<i class="fa fa-spinner fa-spin"></i>)
                                                } @else {
                                                    ({{ company.vendorCodeCount || 0 }})
                                                }
                                            </a>
                                        }
                                        @if (!editMode) {
                                            <span>
                                                @if (vendorCodeCountLoading) {
                                                    <i class="fa fa-spinner fa-spin"></i>
                                                } @else {
                                                    {{ company.vendorCodeCount || 0 }}
                                                }
                                            </span>
                                        }
                                    </span>
                                }
                            </div>
                        }
                        <div class="setting">
                            <span style="margin-right: 10px; font-weight: bold; display: inline-block;">
                                Fiscal Year Start:
                            </span>
                            <input type="text"
                                   class="form-control sd-validate-input-text"
                                   [(ngModel)]="options.fiscalYearStart"
                                   required
                                   pattern="(0?[1-9]|1[012])/(0?[1-9]|[12]\d|3[01])"
                                   title="Value format is MM/DD"
                                   name="fiscalYearStartInput"
                                   style="width:60px; display: inline-block;"
                                   [disabled]="!editMode"/>
                        </div>
                        @if (isTopLevelCompany && !dxpSyncDisabled && entityIsInRyanInstance) {
                            <div class="setting">
                                <span style="margin-right: 10px; font-weight: bold;">
                                    Sync with Tax Access:
                                </span>
                                <ws-switch [(ngModel)]="options.syncDXPFlag"
                                           [disabled]="!editMode || syncDxpLocked"
                                           size="small">
                                </ws-switch>
                            </div>
                        }
                        @if (showInvoiceAppealSavingsSetting) {
                            <div class="setting">
                                <div>
                                    <span style="margin-right: 10px; font-weight: bold; padding-right: 4px;"
                                          [ngClass]="{'red': invoiceAppealSavingsOverridden()}">
                                        Invoice Appeal Savings:
                                    </span>
                                    <ws-switch [(ngModel)]="options.invoiceAppealSavingsFlag"
                                               [disabled]="!this.editMode || !this.entityIsInRyanInstance">
                                    </ws-switch>
                                </div>
                                <div>
                                    <span style="margin-right: 10px; font-weight: bold;"
                                          [ngClass]="{'red': requireClientApprovalOverridden()}">
                                        Client Appeal Recommendation:
                                    </span>
                                    <ws-switch [(ngModel)]="options.requireClientApprovalFlag"
                                               [disabled]="!this.editMode || !this.entityIsInRyanInstance">
                                    </ws-switch>
                                </div>
                            </div>
                        }
                        @if (isTopLevelCompany) {
                            <div class="setting">
                                <div>
                                    <span style="margin-right: 10px; font-weight: bold;">
                                        Budgets Enabled:
                                    </span>
                                    <ws-switch [(ngModel)]="options.budgetsEnabled"
                                               (selectedOptionChanged)="budgetEnabledChanged($event)"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                                @if (options.budgetsEnabled) {
                                    <div style="margin-top: 10px;">
                                        <label style="margin-right: 5px;">Basis:</label>
                                        <ws-select [(ngModel)]="options.budgetBasis"
                                                   labelProperty="name"
                                                   [options]="budgetBasisOptions"
                                                   [disabled]="!editMode">
                                        </ws-select>
                                        <div style="margin-top: 10px;">
                                            @if (flatInUseDescriptors) {
                                                <budget-descriptors-link
                                                    [companyId]="company.companyID"
                                                    [flatInUseDescriptors]="flatInUseDescriptors"
                                                    [options]="options"
                                                    [editMode]="editMode">
                                                </budget-descriptors-link>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (isTopLevelCompany && accrualsEnabled) {
                            <div class="setting">
                                <div>
                                    <span style="margin-right: 10px; font-weight: bold;">
                                        Accruals Enabled:
                                    </span>
                                    <ws-switch [(ngModel)]="options.accrualsEnabled"
                                               (selectedOptionChanged)="accrualsEnabledChanged($event)"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                                @if (options.accrualsEnabled) {
                                    <div>
                                        <div style="margin-top: 10px;">
                                            <accounting-periods-link [companyId]="company.companyID"
                                                                     [editMode]="editMode"></accounting-periods-link>
                                        </div>
                                        <div style="margin-top: 10px;">
                                            @if (flatInUseDescriptors) {
                                                <accruals-descriptors-link
                                                    [companyId]="company.companyID"
                                                    [flatInUseDescriptors]="flatInUseDescriptors"
                                                    [options]="options"
                                                    [editMode]="editMode">
                                                </accruals-descriptors-link>
                                            }
                                        </div>
                                        <div style="margin-top: 10px;">
                                            <accrual-paid-date-precedences-link
                                                [companyId]="company.companyID"
                                                [options]="options"
                                                [editMode]="editMode">
                                            </accrual-paid-date-precedences-link>
                                        </div>
                                        <div style="margin-top: 10px;">
                                            <label style="margin-right: 5px;">Tax Amount Adjustments:</label>
                                            <ws-select [(ngModel)]="options.defaultAccrualAdjustmentMethodId"
                                                       labelProperty="name"
                                                       [options]="taxAmountAdjustments"
                                                       [disabled]="!editMode">
                                            </ws-select>
                                        </div>
                                        <div style="margin-top: 10px;">
                                            <label style="margin-right: 5px;">Economic Unit:</label>
                                            <ws-select [(ngModel)]="options.accrualEconUnitTypeId"
                                                       labelProperty="name"
                                                       valueProperty="economicUnitTypeId"
                                                       [disabled]="!editMode"
                                                       [options]="economicUnitTypes">
                                            </ws-select>
                                        </div>
                                        @if (options.accrualEconUnitTypeId === 3) {
                                            <div style="margin-top: 10px;">
                                                <label style="margin-right: 5px;">Economic Unit Site Code:</label>
                                                <descriptor-picker style="display: inline-block; width: auto;"
                                                                   [companyId]="company.companyID"
                                                                   [entityTypeId]="5"
                                                                   [descriptorId]="options.accrualEconUnitDescriptorId"
                                                                   [disabled]="!editMode"
                                                                   (selected)="descriptorSelected($event)">
                                                </descriptor-picker>
                                            </div>
                                        }
                                        <div style="margin-top: 10px;">
                                            <label style="margin-right: 5px;">Export File Type:</label>
                                            <ws-select [(ngModel)]="options.accrualFileTypeId"
                                                       [options]="exportFileTypes"
                                                       valueProperty="accrualFileTypeId"
                                                       labelProperty="name"
                                                       [disabled]="!editMode">
                                            </ws-select>
                                        </div>
                                        <div style="margin-top: 10px;">
                                            <label style="margin-right: 5px;">Export Property Identifier:</label>
                                            <ws-select [ngModel]="options.accrualExportPropertyIdentificationId"
                                                       [options]="exportProperties"
                                                       labelProperty="name"
                                                       (ngModelChange)="exportPropertyChanged($event)"
                                                       [disabled]="!editMode">
                                            </ws-select>
                                            <div style="margin-top: 8px;">
                                                @if (!siteNumberSelectedForExport) {
                                                    <accruals-descriptor-selector
                                                        [(selectedDescriptorId)]="options.accrualExportPropIdentDescriptorId"
                                                        placeholder="Choose Descriptor"
                                                        [disabled]="!editMode"
                                                        [inUseDescriptors]="siteCharSelectedForExport ? inUseDescriptors.SITE : inUseDescriptors.PARCEL">
                                                    </accruals-descriptor-selector>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (!isTopLevelCompany && accrualsEnabled && options.tlCompanyAccrualsEnabled) {
                            <div class="setting">
                                <div>
                                    <span style="margin-right: 10px; font-weight: bold;">
                                        Exclude Company From Accruals:
                                    </span>
                                    <ws-switch [(ngModel)]="options.excludeFromAccruals"
                                               [disabled]="!editMode">
                                    </ws-switch>
                                </div>
                            </div>
                        }
                        <div class="setting">
                            <div>
                                <a anchor-route
                                   [sref]="{ target: 'glAccountList', options: { companyId: ((options.useTopLevelCompanyCOA) ? company.topLevelCompanyId : company.companyID)}}">
                                    Chart of Accounts @if (options.useTopLevelCompanyCOA) {
                                    <span>({{ parentCompany.companyName }} and it's subsidiary companies)</span>
                                }
                                </a>
                            </div>
                            @if (!isTopLevelCompany) {
                                <div style="margin-top: 10px;">
                                    <span style="margin-right: 10px; font-weight: bold;">
                                        Use Top-Level Company Chart of Accounts:
                                    </span>
                                    <ws-switch [(ngModel)]="options.useTopLevelCompanyCOA"
                                               [disabled]="!editMode || !canChangeUseTopLevelCompanyCOA"
                                               [title]="useTopLevelCompanyCOATitle">
                                    </ws-switch>
                                </div>
                            }
                        </div>
                        @if (hasManageConsultingEngagements && isTopLevelCompany) {
                            <div class="setting">
                                <span><strong>Consultants: </strong></span> @if (editMode) {
                                <a class="pointer" (click)="showContracts()">Manage</a>
                            }
                            </div>
                        }
                        @if (company.hasIncomeStatements && isTopLevelCompany) {
                            <div class="setting">
                                <a anchor-route
                                   [sref]="{ target: 'companyIncomeStatement', options: { companyId: company.companyID}}">
                                    Income Statements
                                </a>
                            </div>
                        }
                        @if (company.hasRentRolls && isTopLevelCompany) {
                            <div class="setting">
                                <a anchor-route
                                   [sref]="{ target: 'companyRentRoll', options: { companyId: company.companyID}}">
                                    Rent Rolls
                                </a>
                            </div>
                        }
                    </div>
                    <div class="col-lg-6">
                        <div class="card panel-flat-color secondary-panel small-panel"
                             style="margin-bottom: 0; overflow: initial;">
                            <div class="panel-flat-header small-header">
                                <h3>Utilities</h3>
                            </div>
                            <div class="card-body">
                                <div class="setting">
                                    <div class="ws-flex-container-horizontal ws-flex-align-items-center spacing-bottom">
                                        <label class="utilities-form-label">Year</label>
                                        <ws-select class="ws-stretch-width"
                                                   [(ngModel)]="yearToAdd"
                                                   [options]="yearsToAdd"
                                                   [isPrimitive]="true"
                                                   [disabled]="!editMode">
                                        </ws-select>
                                        @if (editMode) {
                                            <button
                                                class="ace-btn has-icon btn-primary btn-sm spacing-margin"
                                                (click)="startAddYear()"
                                                helpTooltip
                                                tooltipText="Add Year"
                                                [disabled]="addingYear || (selectingState && !companyStateModel.stateNames.length)">
                                                <i class="fa fa-plus"></i>
                                            </button>
                                        }
                                    </div>
                                    @if (editMode && addingYear) {
                                        <div class="ws-flex-container-vertical">
                                            @if (companyStates && companyStates.length) {
                                                <div class="ws-flex-container-horizontal ws-flex-align-items-center ws-stretch-width spacing-bottom">
                                                    <label class="utilities-form-label">Select States</label>
                                                    <span class="checkbox-container" [class.disabled]="!editMode">
                                                        <input type="checkbox"
                                                               [checked]="selectingState"
                                                               [disabled]="!editMode">
                                                        <span class="checkbox-checkmark"
                                                              (click)="toggleSelectingState()"></span>
                                                    </span>
                                                    <div class="ws-flex-grow spacing-margin">
                                                        <ws-multi-select class="ws-stretch-width"
                                                                         [(ngModel)]="companyStateModel.stateNames"
                                                                         [options]="companyStates"
                                                                         [isPrimitive]="true"
                                                                         [disabled]="!(selectingState && editMode)">
                                                        </ws-multi-select>
                                                    </div>
                                                </div>
                                            }
                                            <div class="ws-flex-container-horizontal ws-flex-justify-content-flex-end">
                                                @if (editMode) {
                                                    <button
                                                        class="ace-btn btn-primary btn-danger btn-sm"
                                                        (click)="cancelAddYear()"
                                                        helpTooltip
                                                        tooltipText="Cancel">
                                                        Cancel
                                                    </button>
                                                }
                                                @if (editMode) {
                                                    <button
                                                        class="ace-btn btn-primary btn-sm"
                                                        (click)="addYear(yearToAdd)"
                                                        helpTooltip
                                                        tooltipText="Add Year"
                                                        [disabled]="selectingState && !companyStateModel.stateNames.length">
                                                        Add Year
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (isTopLevelCompany && allowEdit && canImportData) {
                                    <div class="setting">
                                        <a anchor-route
                                           [sref]="{ target: 'companyImports', options: {companyId: company.companyID} }">
                                            Data Imports
                                        </a>
                                    </div>
                                }
                            </div>
                        </div>
                        @if (showAllocations) {
                            <div class="card panel-flat-color secondary-panel small-panel" style="margin-top: 10px;">
                                <div class="panel-flat-header small-header">
                                    <h3>Allocations</h3>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <span style="margin-right: 10px; font-weight: bold;"
                                              [ngClass]=" {'red': enableAllocationsOverridden()}">
                                            Allocations:
                                        </span>
                                        <ws-switch [(ngModel)]="options.enableAllocations"
                                                   [disabled]="!this.editMode">
                                        </ws-switch>
                                    </div>
                                    <div>
                                        <a anchor-route
                                           [sref]="{ target: 'responsibleEntityList', options: {companyId: company.topLevelCompanyId} }">{{ isTopLevelCompany ? 'Responsible Entities' : 'Responsible Entities (Top Company and its subsidiary companies)' }}</a>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (entityIsInRyanInstance) {
                            <div class="card panel-flat-color secondary-panel small-panel" style="margin-top: 10px;">
                                <div class="panel-flat-header small-header">
                                    <h3>Payment Batch Settings</h3>
                                </div>
                                <div class="card-body">
                                    <div style="margin-bottom: 10px;">
                                        @if (flatInUseDescriptors) {
                                            <payment-batch-descriptors-link
                                                [companyId]="company.companyID"
                                                [editMode]="editMode"
                                                [flatInUseDescriptors]="flatInUseDescriptors"
                                                [options]="options">
                                            </payment-batch-descriptors-link>
                                        }
                                    </div>
                                    @if (enablePaymentBatchDataHub) {
                                        <div class="setting">
                                            <div>
                                                <span style="margin-right: 10px; font-weight: bold;">
                                                    Data Hub Enabled:
                                                </span>
                                                @if (isTopLevelCompany) {
                                                    <ws-switch
                                                        [(ngModel)]="options.dataHubEnabled"
                                                        [disabled]="!editMode">
                                                    </ws-switch>
                                                }
                                                @if (!isTopLevelCompany) {
                                                    <span>{{ options.dataHubEnabled ? 'Yes' : 'No' }}</span>
                                                }
                                            </div>
                                            @if (options.dataHubEnabled) {
                                                <div>
                                                    <span style="margin-right: 10px; margin-top: 15px; font-weight: bold; display: inline-block;">
                                                        Data Hub Client Tenant Id:
                                                    </span>
                                                    @if (isTopLevelCompany && editMode) {
                                                        <input type="text" [(ngModel)]="options.dataHubClientTenantId"
                                                            style="width: 300px; display: inline-block;"
                                                            maxlength="50"
                                                            [required]>
                                                    }
                                                    @if (!isTopLevelCompany || !editMode) {
                                                        <span>{{ options.dataHubClientTenantId }}</span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (enableLitigationReferrals) {
                                <div class="setting">
                                    <div>
                                        <span class="fw-bold me-2">Allow Litigation Referrals:</span>
                                        @if (isTopLevelCompany) {
                                            <ws-switch
                                                [(ngModel)]="options.litigationReferralsEnabled"
                                                [disabled]="!editMode">
                                            </ws-switch>
                                        }
                                        @if (!isTopLevelCompany) {
                                            <span>{{ options.litigationReferralsEnabled ? 'Yes' : 'No' }}</span>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
